var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlinkCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7733_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 16.4702C12.4011 16.4702 15.9696 12.9016 15.9696 8.50009C15.9696 4.09862 12.4011 0.530029 7.99979 0.530029C3.59849 0.530029 0.0300293 4.09862 0.0300293 8.50009C0.0300293 12.9016 3.59849 16.4702 7.99979 16.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 0.871338C3.78639 0.871338 0.370605 4.28725 0.370605 8.50071C0.370605 12.7142 3.78639 16.1301 7.99969 16.1301C12.213 16.1301 15.6288 12.7142 15.6288 8.50071C15.6288 4.28725 12.213 0.871338 7.99969 0.871338ZM6.907 12.3375C3.69059 10.1874 0.0957861 6.22124 2.90805 3.40887C5.7203 0.596508 10.2791 0.596508 13.0913 3.40887C15.3761 5.69373 15.6378 9.05875 14.3762 11.8496C13.6356 13.4878 10.2132 14.5476 6.907 12.3375Z",
    fill: "#9583FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37838 7.94919C4.21672 7.50409 3.05896 7.05147 1.8999 6.6001C2.73375 8.51466 3.55459 10.4342 4.37152 12.3551C5.47074 12.7964 6.56996 13.2265 7.6965 13.6001C7.45584 12.9343 7.20477 12.2711 6.942 11.6128C7.93976 11.9852 8.94792 12.3375 9.96258 12.6635C10.9903 12.1908 11.9815 11.6341 12.8999 10.9859C11.815 10.5972 10.7366 10.1872 9.65818 9.781C8.69295 10.2399 7.71081 10.6549 6.71305 11.0448C6.28898 10.0042 5.84408 8.9723 5.37708 7.94919H5.37838Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47118 5.68349C9.98564 5.45631 10.5718 5.71718 10.8005 6.17732C11.0281 6.66056 10.8597 7.2468 10.3494 7.5096C9.82455 7.74737 9.21863 7.4942 8.99414 7.01192C8.77069 6.52675 8.95049 5.93088 9.47118 5.68349Z",
    fill: "#9583FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7733_3437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99979 16.4702C12.4011 16.4702 15.9696 12.9016 15.9696 8.50009C15.9696 4.09862 12.4011 0.530029 7.99979 0.530029C3.59849 0.530029 0.0300293 4.09862 0.0300293 8.50009C0.0300293 12.9016 3.59849 16.4702 7.99979 16.4702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99969 0.871094C3.78639 0.871094 0.370605 4.28701 0.370605 8.50046C0.370605 12.7139 3.78639 16.1298 7.99969 16.1298C12.213 16.1298 15.6288 12.7139 15.6288 8.50046C15.6288 4.28701 12.213 0.871094 7.99969 0.871094ZM6.907 12.3373C3.69059 10.1872 0.0957861 6.22099 2.90805 3.40863C5.7203 0.596264 10.2791 0.596264 13.0913 3.40863C15.3761 5.69349 15.6378 9.0585 14.3762 11.8493C13.6356 13.4875 10.2132 14.5473 6.907 12.3373Z",
    fill: "#FBC44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7143 7.25C11.7143 7.94036 11.1387 8.5 10.4286 8.5C9.71849 8.5 9.14286 7.94036 9.14286 7.25C9.14286 6.55964 9.71849 6 10.4286 6C11.1387 6 11.7143 6.55964 11.7143 7.25Z",
    fill: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57143 11.1302V9.75H5.28571L6.57143 11.1302Z",
    fill: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.5L9.50674 9.75H6.57143V11.1302L8.77898 13.5H13Z",
    fill: "#1E1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.57143 6.35713L4 3.5L4 10.6429L6.57143 13.5V11.1302L5.28571 9.75H6.57143V6.35713Z",
    fill: "#1E1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7733_3437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7733_3437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlinkCoin);
export default __webpack_public_path__ + "static/media/Klink-Coin.ed47e212c70ba1c022afbc4219abb45d.svg";
export { ForwardRef as ReactComponent };